import styled, { css } from "styled-components";
import { BREAK_POINT, MENUS } from "../constants";
import { Z_INDEX } from "../constants/zIndex";
import { useEffect, useState } from "react";

const Header = () => {
  const [openNav, setOpenNav] = useState(false);
  const [sectionId, setSectionId] = useState("");

  const handleNavigation = (id: string) => {
    const el = document.getElementById(id);
    const contentEl = document.getElementById("content");
    if (id === "synopsys") {
      contentEl?.scrollTo({ top: 1, left: 0, behavior: "smooth" });
    } else if (id !== "" && el) {
      el.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  };

  useEffect(() => {
    const contentEl = document.getElementById("content");
    if (contentEl) {
      if (openNav) {
        contentEl.style.overflowY = "hidden";
        contentEl.style.touchAction = "none";
      } else {
        contentEl.style.overflowY = "scroll";
        contentEl.style.touchAction = "auto";

        handleNavigation(sectionId);
      }
    }
  }, [openNav, sectionId]);

  return (
    <Wrapper>
      <StyledNav $openNav={openNav}>
        <ul>
          {MENUS.map((menu, idx) => (
            <li
              key={menu.id}
              onClick={() => {
                setOpenNav(false);
                setSectionId(menu.id);
              }}
            >
              {menu.title}
            </li>
          ))}
        </ul>
        <img
          src="/assets/logo.png"
          alt="logo"
          onClick={() => handleNavigation("synopsys")}
        />
        <Hamburger
          $active={openNav}
          $showBurger={!openNav}
          onClick={() => {
            setOpenNav(!openNav);
            setSectionId("");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Hamburger>
      </StyledNav>
    </Wrapper>
  );
};

export default Header;

const Wrapper = styled.nav`
  position: fixed;
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: ${Z_INDEX.HEADER};

  img {
    display: none;
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    height: 40px;

    img {
      display: block;
      object-fit: contain;
      max-width: 92px;
    }
  }
`;

const StyledNav = styled.nav<{ $openNav: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  @media only screen and (min-width: ${BREAK_POINT.tablet}) {
    background: var(--white);
    height: 70px;

    ul {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    li {
      flex: 1;
      max-width: 170px;
      height: 100%;
      color: var(--primary);
      font-size: 2rem;
      font-weight: 700;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    background: var(--primary);
    padding: 0 8px;
    height: 40px;

    ul {
      position: absolute;
      width: 100%;
      height: calc(var(--nav-height, 1vh));
      top: 0;
      right: ${({ $openNav }) => ($openNav ? 0 : "-100%")};
      transition: right 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
      z-index: 2;
      background: var(--primary);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 24px;
    }

    li {
      font-size: 3rem;
      color: var(--white);
      font-weight: 400;
    }
  }
`;

const Hamburger = styled.div<{
  $active: boolean;
  $showBurger: boolean;
}>`
  position: absolute;
  width: 24px;
  top: 10px;
  right: 10px;
  height: 18px;
  z-index: 3;
  cursor: pointer;

  &,
  span {
    display: inline-block;
    transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    box-sizing: border-box;
  }

  span {
    position: absolute;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: var(--white);
    border-radius: 4px;
  }

  span:nth-of-type(1) {
    top: 0;
  }

  span:nth-of-type(2) {
    top: 8px;
  }

  span:nth-of-type(3) {
    bottom: 0;
  }

  ${({ $active }) =>
    $active &&
    css`
      span:nth-of-type(1) {
        -webkit-transform: translateY (9px) rotate (-45deg);
        transform: translateY(9px) rotate(-45deg);
      }

      span:nth-of-type(2) {
        opacity: 0;
      }

      span:nth-of-type(3) {
        -webkit-transform: translateY(-8px) rotate(45deg);
        transform: translateY(-8px) rotate(45deg);
      }
    `}

  @media only screen and (min-width: ${BREAK_POINT.tablet}) {
    display: none;
  }
`;
